(function(){
  if(window.__tpkSticky)return;window.__tpkSticky=1;
  var d=document;
  var hd,ann,spacer,drawer,portal;
  var annH=0,hdH=0,ticking=false,lastY=-1,scrolled=false;

  function grab(){
    hd=d.querySelector('[data-tpk-header]');
    ann=d.querySelector('[data-tpk-ann]');
    spacer=d.querySelector('[data-tpk-spacer]');
    drawer=d.getElementById('tpk-drawer');
    return !!hd;
  }

  /* Horizon annida l'header in body > .page-wrapper > #header-group.
     Qualunque ancestor con transform/contain neutralizza fixed e sticky,
     quindi portiamo announcement + header dentro un wrapper figlio di body.
     Lo spacer nel flusso tiene lo spazio esatto: nessuna striscia vuota. */
  function build(){
    [].slice.call(d.querySelectorAll('body > .tpk-hd__portal')).forEach(function(el){
      if(el!==portal)el.remove();
    });
    if(!portal||!portal.isConnected){
      portal=d.createElement('div');
      portal.className='tpk-hd__portal';
      d.body.appendChild(portal);
    }
    if(ann&&ann.parentElement!==portal)portal.appendChild(ann);
    if(hd.parentElement!==portal)portal.appendChild(hd);
    if(drawer&&drawer.parentElement!==d.body)d.body.appendChild(drawer);
    hd.classList.add('is-portal');
  }

  function measure(){
    annH=ann?ann.offsetHeight:0;
    var y=window.pageYOffset||d.documentElement.scrollTop||0;
    if(y<=2){hdH=hd.offsetHeight;}
    if(spacer)spacer.style.height=(annH+hdH)+'px';
  }

  function update(){
    ticking=false;
    var y=window.pageYOffset||d.documentElement.scrollTop||0;
    var shift=y<annH?y:annH;
    if(shift!==lastY){
      portal.style.transform=shift?'translate3d(0,'+(-shift)+'px,0)':'none';
      lastY=shift;
    }
    var s=y>annH+24;
    if(s!==scrolled){scrolled=s;hd.classList.toggle('is-scrolled',s);}
  }

  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}

  function init(){
    if(!grab())return;
    build();
    measure();update();
  }

  if(d.readyState!=='loading'){init();}else{d.addEventListener('DOMContentLoaded',init);}
  window.addEventListener('load',function(){measure();update();});
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){measure();update();});
  if(d.fonts&&d.fonts.ready)d.fonts.ready.then(function(){measure();update();});
  d.addEventListener('shopify:section:load',function(e){
    if(e.target&&e.target.querySelector&&e.target.querySelector('[data-tpk-header]'))init();
  });
})();

/* BANNER COOKIE SOPRA I WIDGET DELLE APP (agg. 02/10, LIVE 6.1)
   Il banner nativo di Shopify (#shopify-pc__banner) deve stare sopra a tutto. Alcune app
   (launcher Rivo, pop-up) usano il livello massimo di z-index, che il CSS non puo superare,
   e nomi interni che possono cambiare. Finche il banner e visibile, questo script cerca gli
   elementi fissi con z-index piu alto di quello consentito e li abbassa di un gradino;
   quando il banner si chiude ripristina il valore originale. Non dipende dal nome usato
   dall'app, quindi regge anche ai suoi aggiornamenti. */
(function(){
  if(window.__tpkConsentLayer)return;window.__tpkConsentLayer=1;
  var d=document,CAP=2147483000,lowered=[],timer=null,checks=0;
  function banner(){return d.getElementById('shopify-pc__banner');}
  function isVisible(el){
    if(!el||!el.isConnected)return false;
    var cs=getComputedStyle(el);
    return cs.display!=='none'&&cs.visibility!=='hidden'&&el.getClientRects().length>0;
  }
  function restore(){
    lowered.forEach(function(it){
      if(it.prev)it.el.style.setProperty('z-index',it.prev,it.prio);
      else it.el.style.removeProperty('z-index');
    });
    lowered=[];
  }
  function lower(b){
    b.style.setProperty('z-index','2147483647','important');
    var all=d.body.getElementsByTagName('*');
    for(var i=0;i<all.length;i++){
      var el=all[i];
      if(el===b||b.contains(el)||el.contains(b))continue;
      var cs=getComputedStyle(el);
      if(cs.position!=='fixed'&&cs.position!=='sticky')continue;
      var z=parseInt(cs.zIndex,10);
      if(!(z>CAP))continue;
      if(lowered.some(function(it){return it.el===el}))continue;
      lowered.push({el:el,prev:el.style.getPropertyValue('z-index'),prio:el.style.getPropertyPriority('z-index')});
      el.style.setProperty('z-index',String(CAP),'important');
    }
  }
  function check(){
    var b=banner();
    if(isVisible(b)){lower(b);return true;}
    restore();return false;
  }
  function loop(){
    /* controlla ogni secondo finche il banner e aperto: le app aggiungono i launcher
       anche dopo il caricamento della pagina. Si ferma da solo quando il banner si chiude
       o, se il banner non compare, dopo 15 secondi. */
    if(timer)return;
    timer=setInterval(function(){
      checks++;
      var open=check();
      if((!open&&checks>15)||(!open&&lowered.length===0&&checks>3&&!banner())){clearInterval(timer);timer=null;}
      if(!open&&banner()===null&&checks>15){clearInterval(timer);timer=null;}
    },1000);
  }
  function start(){check();loop();}
  if(d.readyState!=='loading')start();else d.addEventListener('DOMContentLoaded',start);
  window.addEventListener('load',start);
  d.addEventListener('click',function(e){
    if(e.target&&e.target.closest&&e.target.closest('#shopify-pc__banner'))setTimeout(check,300);
  },true);
})();